export default __webpack_public_path__ + "static/media/oi_0.6fd6666d.mp3";